import { render } from "./CiptaKarya.vue?vue&type=template&id=c2b6926c"
import script from "./CiptaKarya.vue?vue&type=script&lang=js"
export * from "./CiptaKarya.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__